import { FC, useEffect, useState } from 'react';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { IconButton } from '../../../../../../../components/icon-button/icon-button';
import { InlineInputs } from '../../../../../../../components/inline-inputs/inline-inputs';
import { LangInput } from '../../../../../../../features/lang-input/lang-input';
import { LangType } from '../../../../../../../helpers/lang';

interface Props {
  onConfirm?: (data?: LangType) => Promise<void>;
  placeholder: string;
  isLoading?: boolean;
  name?: string;
  value?: LangType;
  showLanguageSelect?: boolean;
  'data-testid'?: string;
}

export const MenuInformerCreateUnit: FC<Props> = (props) => {
  const { onConfirm, placeholder, isLoading, name, value, showLanguageSelect = true } = props;

  const [editValue, setEditValue] = useState<LangType>({});

  const handleConfirm = async () => {
    try {
      await onConfirm?.(editValue);
      setEditValue({});
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    setEditValue(value || {});
  }, [value]);

  return (
    <InlineInputs>
      <LangInput
        placeholder={placeholder}
        onChange={setEditValue}
        name={name}
        showLanguageSelect={showLanguageSelect}
        value={editValue}
        data-testid={`${props['data-testid']}-input`}
      />
      {onConfirm && (
        <IconButton
          disabled={isLoading}
          size="lg"
          onClick={handleConfirm}
          data-testid={`${props['data-testid']}-confirm-button`}
        >
          <FaRegCircleCheck />
        </IconButton>
      )}
    </InlineInputs>
  );
};
